/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Row, Col } from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faMinusCircle,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import useCreateAssessmentKitTopic from "./useCreateAssessmentKitTopic";
import { SkillSearchInput } from "../../../../_uiComponents/Search/SkillSearchInput";

export default (props) => {
  const {
    formInputsError,
    topicQuestions,
    addNewQuestion,
    onTopicDataChange,
    onTopicTitleChange,
    onSaveTopicClick,
    onAddNewQuestion,
    onSaveQuestion,
    onDeleteQuestion,
    onDeleteTopicClick,
    onCancelTopicClick,
    formData,

    showCreateQuestion,
    editInterviewKitItemId,

    onCreateNewTopic,
    onInterviewTopicEdit,
  } = useCreateAssessmentKitTopic(props);
  return (
    <div className="py-4">
      {formData?.topics &&
        Array.isArray(formData.topics) &&
        formData.topics.map((topic) => (
          <div className="border rounded-lg px-4 mb-3 bg-white">
            <div className="top bg-grey-2 py-3 px-4 mx-n4 d-flex justify-content-between align-items-center">
              <h4 className="font-weight-medium text-left">
                {topic?.name && topic.name.toUpperCase()}
              </h4>
              <FontAwesomeIcon
                icon={faPencil}
                className="text-grey-4 cursor-pointer"
                onClick={() => onInterviewTopicEdit(topic)}
                disabled={showCreateQuestion}
              />
            </div>
            {editInterviewKitItemId === topic?.id || topic.id === undefined ? (
              <div className="py-2 my-3">
                <div className="row">
                  <div className="form-group py-3 mb-0  col-9">
                    <input
                      className="form-control bg-transparent"
                      type="text"
                      placeholder="Enter topic name"
                      name="topic_name"
                      onChange={(e) => {
                        onTopicDataChange(e);
                      }}
                      onBlur={(e) => onTopicTitleChange(e)}
                      defaultValue={topicQuestions?.topic_name}
                    />
                  </div>

                  <div className="form-group py-3 mb-0 col-3">
                    {topicQuestions?.id ? null : (
                      <button
                        className="btn btn-primary"
                        onClick={() => onSaveTopicClick()}
                      >
                        Save Topic
                      </button>
                    )}

                    {topicQuestions?.id && (
                      <>
                        <button
                          className="btn btn-outline-light mr-3"
                          onClick={() => onCancelTopicClick()}
                        >
                          Cancel
                        </button>
                        <span
                          className="cursor-pointer font-weight-medium text-danger"
                          onClick={() => onDeleteTopicClick()}
                        >
                          <FontAwesomeIcon
                            icon={faMinusCircle}
                            className="mr-1"
                          />{" "}
                          Delete
                        </span>
                      </>
                    )}
                  </div>
                </div>
                {topicQuestions?.questions &&
                  Array.isArray(topicQuestions?.questions) &&
                  topicQuestions.questions.map((item, index) => (
                    <Row className="mb-4 mt-3 align-items-start">
                      <Col md={9} className="mb-4  mb-md-0 form-group">
                        <input
                          rows="4"
                          className="form-control bg-grey ques-input"
                          name="question"
                          onChange={(e) => {
                            onTopicDataChange(e, index);
                          }}
                          defaultValue={item?.question}
                          placeholder="Enter your question here"
                        ></input>
                      </Col>

                      <Col md={3} className="form-group mb-0">
                        <SkillSearchInput
                          className="form-control w-100 mb-3"
                          placeholder={"Skill Tag"}
                          onSearchSelect={(item) =>
                            onTopicDataChange(
                              { target: { value: item, name: "skills" } },
                              index
                            )
                          }
                          clearSearch={false}
                          defaultSkillValue={
                            item?.skill_names && item.skill_names[0]
                          }
                        />
                        <div className="flex-grow-1">
                          <div className="form-group mb-0">
                            <input
                              type="number"
                              className="form-control bg-grey mt-2"
                              placeholder="Enter time to answer"
                              name="time_to_answer"
                              onChange={(e) => {
                                onTopicDataChange(e, index);
                              }}
                              defaultValue={item?.time_to_answer}
                            />
                          </div>
                        </div>
                        <div className="flex-grow-1 mt-2">
                          <div className="form-group mb-0">
                            <input
                              type="checkbox"
                              id="is_public"
                              name="is_public"
                              value="Public"
                              className="bg-grey mr-1"
                              defaultChecked={item?.is_public}
                              onChange={(e) =>
                                onTopicDataChange(
                                  {
                                    target: {
                                      name: "is_public",
                                      value: !item?.is_public,
                                    },
                                  },
                                  index
                                )
                              }
                            />
                            Set as a public question
                          </div>
                        </div>
                        {/* functionality of adding as a coding question */}
                        {/* <div className="flex-grow-1 mt-2">
                          <div className="form-group mb-0">
                            <input
                              type="checkbox"
                              id="is_public"
                              name="is_public"
                              value="Public"
                              className="bg-grey mr-1"
                              // defaultChecked={item?.is_coding_question}
                              // onChange={(e) =>
                              //   onTopicDataChange(
                              //     {
                              //       target: {
                              //         name: "is_public",
                              //         value: !item?.is_public,
                              //       },
                              //     },
                              //     index
                              //   )
                              // }
                            />
                            Ask as a Code Question
                          </div>
                        </div> */}
                      </Col>

                      <Col md={12} className="d-flex align-items-center mt-4">
                        <div className="left">
                          {topicQuestions?.id && (
                            <button
                              className="btn btn-primary mr-3 mb-1"
                              onClick={() => onSaveQuestion(item)}
                            >
                              Save
                            </button>
                          )}
                        </div>
                        <span
                          className="cursor-pointer font-weight-medium text-danger"
                          onClick={() => onDeleteQuestion(index, item)}
                        >
                          <FontAwesomeIcon
                            icon={faMinusCircle}
                            className="mr-1"
                          />{" "}
                          Delete Question
                        </span>
                      </Col>
                    </Row>
                  ))}

                {formInputsError?.topic_error &&
                formInputsError.topic_error.length > 0 ? (
                  <span className="text-danger mt-1 line-height-14 d-inline-block">
                    {formInputsError.topic_error}
                  </span>
                ) : null}
                {addNewQuestion && topic?.id && (
                  <p
                    className="cursor-pointer text-primary font-weight-medium text-left mb-3"
                    onClick={() => onAddNewQuestion()}
                  >
                    + Add new question
                  </p>
                )}
              </div>
            ) : (
              <ol className="questions-wrapper mb-0">
                {topic?.questions &&
                  Array.isArray(topic?.questions) &&
                  topic.questions.map((question) => (
                    <li className="list d-flex align-items-center mb-2">
                      <span className="d-inline-block mr-2">
                        <FontAwesomeIcon icon={faBars} />
                      </span>
                      <div className="inner-box d-flex flex-grow-1 mr-2 justify-content-between align-items-center">
                        <p className="d-inline-block mb-0 mr-2">
                          {question.question}
                        </p>
                        <div>
                          <p className="mb-0 d-inline-block text-primary mr-2 py-1 px-2 bg-light-blue rounded-pill mb-1">
                            {question.time_to_answer} mins to answer
                          </p>
                          <span className="mb-0 d-inline-block text-primary mr-2 py-1 px-2 bg-light-blue rounded-pill mb-1">
                            {question?.skill_names && question.skill_names[0]}
                          </span>
                          {/* <span className="mb-0 d-inline-block text-primary mr-2 py-1 px-2 bg-light-blue rounded-pill">
                            {question?.is_public ? "Public" : "Private"}
                          </span> */}
                        </div>
                      </div>
                      <span
                        className="cursor-pointer font-weight-medium"
                        onClick={() => onDeleteTopicClick()}
                      >
                        <FontAwesomeIcon
                          icon={faMinusCircle}
                          className="ml-2 text-danger"
                        />
                      </span>
                    </li>
                  ))}
              </ol>
            )}
          </div>
        ))}

      <div className="text-center ">
        <p className="my-2">
          {formData?.topics && formData?.topics.length > 0 ? null : (
            <>
              <img src="/assets/images/no-question-placeholder.png" alt="" />
              <p>
                No questions in your video interview, yet. <br />
                Create a new topic to start adding them!{" "}
              </p>
            </>
          )}
        </p>
        {!showCreateQuestion && (
          <button
            onClick={() => onCreateNewTopic()}
            className="border text-center bg-transparent w-100 p-3 text-primary font-weight-medium"
          >
            + Create new topic
          </button>
        )}
      </div>
    </div>
  );
};
